export class LabelFilter {
    public id: string;
    public name: string;
    public amountOfItemsForLabel : number;
}